import getInstallationsTotalInstallationPrice from 'services/products/calculations/getInstallationsTotalInstallationPrice';
import IInstallation from 'services/products/calculations/IInstallation';

const INSTALLATION = 'installation';

// The installations that are installation work, not other expenses, subcontracting or own
// production
export const getInstallationWork = (
  installations: (IInstallation & {
    category: string | null;
    section?: null | string;
  })[],
  installationCategories: { category: string; type: string }[]
) =>
  installations.filter(
    (installation) =>
      !installation.section &&
      installationCategories.some(
        (installationCategory) =>
          installationCategory.type === INSTALLATION &&
          installationCategory.category === installation.category
      )
  );

/**
 * True when the position has installation work but no average hourly earnings, so its
 * hours cannot be calculated.
 */
export const isAverageHourlyEarningsMissing = (
  installations: (IInstallation & { category: string | null })[],
  averageHourlyEarnings: number | string | null,
  installationCategories: { category: string; type: string }[]
): boolean => {
  const hourlyEarnings = Number(averageHourlyEarnings);
  const hasHourlyEarnings =
    Number.isFinite(hourlyEarnings) && hourlyEarnings > 0;

  const hasInstallationWork = getInstallationWork(
    installations,
    installationCategories
  ).some((installation) => Number(installation.installationPrice) > 0);

  return hasInstallationWork && !hasHourlyEarnings;
};

/**
 * Installation hours of a position, calculated like in the installation contract of the
 * calculation window: the installation prices of the installations (not other expenses)
 * divided by the average hourly earnings.
 */
const getPositionHours = (
  installations: (IInstallation & { category: string | null })[],
  averageHourlyEarnings: number | string | null,
  quantity: number,
  installationCategories: { category: string; type: string }[]
): number => {
  const hourlyEarnings = Number(averageHourlyEarnings);
  if (!Number.isFinite(hourlyEarnings) || hourlyEarnings === 0) {
    return 0;
  }

  const installationsWithoutOtherExpenses = getInstallationWork(
    installations,
    installationCategories
  );

  const hours =
    getInstallationsTotalInstallationPrice(
      installationsWithoutOtherExpenses,
      quantity
    ) / hourlyEarnings;

  return Number.isFinite(hours) ? hours : 0;
};

export default getPositionHours;
